module.exports = __webpack_public_path__ + "static/media/BOOK.8674c61d.png";